import { render, staticRenderFns } from "./ComponentsUpdate.vue?vue&type=template&id=d5ee5f08&scoped=true&"
import script from "./ComponentsUpdate.vue?vue&type=script&lang=ts&"
export * from "./ComponentsUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./componentsUpdate.scss?vue&type=style&index=0&id=d5ee5f08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ee5f08",
  null
  
)

export default component.exports